export enum LoginMessagesEnum {
    AUTHENTICATION = 'Autenticazione in corso',
    UNAUTHENTICATED = 'Utente non autenticato',
    REDIRECT = 'Reindirizzamento verso il servizio di autenticazione',
    AUTHENTICATION_SUCCESS = 'Autenticazione avvenuta correttamente',
    AUTHENTICATION_ALREADY = 'Utente già autenticato'
}
